export default "__VITE_ASSET__b8712762__"